import { Experiences } from '@local/client-contracts';
import { InstructionDropdownItem } from './assistant-instructions.model';
import { AssistantsIconsConst, Constants } from '@local/common';

type AssistantInstructionsContentModel = {
  optionsResponseLength: InstructionDropdownItem<Experiences.ResponseLength>[];
  optionsAdjustTone: InstructionDropdownItem<Experiences.AdjustTone>[];
  advancedQueryWarning: string;
  learnMoreUrl: Record<Experiences.ExperienceType, string>;
};
export const  ASSISTANT_INSTRUCTIONS_CONTENT: AssistantInstructionsContentModel = {
  optionsResponseLength: [
    {
      label: 'Short',
      subLabel: 'Get brief and focused answers',
      icon: { type: 'font-icon', value: 'icon-short' },
      value: Experiences.ResponseLength.Short,
    },
    {
      label: 'Standard',
      subLabel: 'Receive moderately detailed responses',
      icon: { type: 'font-icon', value: 'icon-medium' },
      value: Experiences.ResponseLength.Standard,
    },
    {
      label: 'Long',
      subLabel: 'Enjoy comprehensive and thorough explanations',
      icon: { type: 'font-icon', value: 'icon-long' },
      value: Experiences.ResponseLength.Long,
    },
  ],
  optionsAdjustTone: [
    {
      label: 'Neutral',
      icon: { type: 'font-icon', value: 'icon-neutral' },
      value: Experiences.AdjustTone.Neutral,
    },
    {
      label: 'Assertive',
      icon: { type: 'font-icon', value: 'icon-assertive' },
      value: Experiences.AdjustTone.Assertive,
    },
    {
      label: 'Confident ',
      icon: { type: 'font-icon', value: 'icon-confident' },
      value: Experiences.AdjustTone.Confident,
    },
  ],
  advancedQueryWarning: 'Unleash cannot fully guarantee an instruction will perform as expected. Please verify its behavior.',
  learnMoreUrl: {
    general: `${Constants.RELEASE_NOTES_URL}unleash-general-assistant#advanced-instructions`,
    rfp: `${Constants.RELEASE_NOTES_URL}rfp-assistant-1#advanced-instructions`,
    salesforce: `${Constants.RELEASE_NOTES_URL}salesforce-case-assistant#advanced-instructions`,
    slack: `${Constants.RELEASE_NOTES_URL}slack-channel-assistant#advanced-settings`,
    teams: `${Constants.RELEASE_NOTES_URL}teams-channel-assistant#advanced-instructions`,
    zendesk: `${Constants.RELEASE_NOTES_URL}zendesk-ticket-assistant#advanced-settings`,
  },
};
